module.exports = __webpack_public_path__ + "static/assets/8f08a38f9e9878088a218ad02360e369.png";